import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import BuyLicense from "../Pages/BuyLicense";

const Dashboard = lazy(() => import("../Components/Dahboard"));
const CreoToolkitvsJlink = lazy(() => import("../Blog/Comparsions/CreoToolkitvsJlink"));
const Whyusecreo = lazy(() => import("../Pages/Whyusecreo"));
const Training = lazy(() => import("../Pages/Training"));
const About = lazy(() => import("../Pages/Howcreo"));
const Consulting = lazy(() => import("../Pages/Consulting"));
const Objecttoolkit = lazy(() => import("../Blog/Comparsions/Objecttoolkit"));
const Solidworks = lazy(() => import("../Blog/Comparsions/Solidworks"));
const DrawingBOMExtraction = lazy(() => import("../Blog/Automationproject/DrawingBOMExtraction"));
const Nxopen = lazy(() => import("../Blog/Comparsions/Nxopen"));
const ExportAutomation = lazy(() => import("../Blog/Automationproject/ExportAutomation"));
const ModelAssemblyAutomation = lazy(() => import("../Blog/Automationproject/ModelAssemblyAutomation"));
const Windchillintegration = lazy(() => import("../Blog/Automationproject/Windchillintegration"));
const UIandEvent = lazy(() => import("../Blog/TutorialArticles/UIandEvent"));
const Drawingmanipulation = lazy(() => import("../Blog/TutorialArticles/Drawingmanipulation"));
const Intro = lazy(() => import("../Blog/TutorialArticles/Intro"));
const Programmingcon = lazy(() => import("../Blog/TutorialArticles/Programmingcon"));
const ContactButton = lazy(() => import("../Components/ContactButton"));




function AppRoutes() {
  return (
    <BrowserRouter>
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
         <Route path="/" element={<Dashboard   />} />
        <Route path="/training" element={<Training />} />
        <Route path="/how-creotoolkit-works" element={<About />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/whyuse-creotoolkit" element={<Whyusecreo />} />
         <Route path="/creotoolkit-vs-j-link" element={<CreoToolkitvsJlink />} />
          <Route path="/creotoolkit-vs-objecttoolkit" element={<Objecttoolkit />} />
           <Route path="/creotoolkit-vs-solidworksapi" element={<Solidworks />} />
           <Route path="/creotoolkit-vs-nxopen" element={<Nxopen />} />
           <Route path="/Drawing-&-BOM-Extraction" element={<DrawingBOMExtraction />} />
           <Route path="/PDF-Export-Automation" element={<ExportAutomation />} />
           <Route path="/Model-&-Assembly-Automation" element={<ModelAssemblyAutomation />} />
           <Route path="/Windchill-Integration" element={<Windchillintegration />} />
           <Route path="/UI-Customization-&-Event Handling" element={<UIandEvent />} />
           <Route path="/Drawing-Manipulation" element={<Drawingmanipulation />} />
           <Route path="/Introduction-to-CreoToolkit" element={<Intro />} />
           <Route path="/Basic-Programming-Concepts" element={<Programmingcon />} />
            <Route path="/Buy-License" element={<BuyLicense />} />

         
      </Routes>
      <ContactButton />
      </Suspense>
      
    </BrowserRouter>
  );
}

export default AppRoutes;